import styled from "@emotion/styled";

export const Body = styled.div`
  &:only-child {
    margin-block-start: 30px;
  }
`;
